// English customer copy follows the canonical Web v3 October 2 simplification.
// Server-owned policy/outcome text, state transitions and permitted actions remain unchanged.
// Spanish: the Founder's full review of 2026-10-06, applied by scripts/apply-spanish-review.js.

export const en = {
  "flow.review.heading": "Review your booking",
  "flow.review.nothingCharged": "",
  "flow.review.expired.title": "Choose your time again",
  "flow.review.expired.body": "",
  "flow.review.expired.action": "Pick a time",
  "flow.review.taken.title": "Choose another time",
  "flow.review.taken.body": "That time is no longer available.",
  "flow.review.taken.action": "See other times",
  "flow.review.failed.title": "We couldn’t book this time",
  "flow.review.failed.body": "We couldn’t finish booking.",
  "flow.review.failed.bodyNoHold": "We couldn’t finish booking.",
  "flow.review.failed.action": "Try again",
  "flow.review.offline": "You’re offline. Reconnect to continue.",
  "flow.review.pay.title": "Pay at the appointment",
  "flow.review.pay.body": "",
  "flow.review.confirm": "Submit booking",
  "flow.review.confirming": "Submitting…",
  "flow.review.approvalNote": "Some appointments need the professional’s approval.",
  "flow.review.policyChanged": "The cancellation policy has changed. Review it before continuing.",
  // A CONSENT TEXT Backend freezes byte for byte: straight ' (the Terms-sentence
  // rule, not the UI typography). Pinned by copyRc10Review.test.ts.
  "flow.review.policyConsent": "By submitting this booking, you agree to the professional's cancellation policy shown above.",
  "flow.confirmed.top": "Booking confirmed",
  "flow.confirmed.heading": "You’re booked",
  "flow.confirmed.when": "{date} at {time} with {business}.",
  "flow.confirmed.schedule": "{date} · {start} – {end}",
  "flow.confirmed.scheduleAt": "{date} · {start} – {end} · {address}",
  "flow.confirmed.paidAt": "Pay at the appointment · booking contact: {email}",
  "flow.confirmed.addToCalendar": "Add to calendar",
  "flow.confirmed.manage": "Cancel or reschedule",
  "flow.confirmed.promo.handoff.title": "Keep this booking with you",
  "flow.confirmed.promo.handoff.body": "Create a free Lura account and this appointment comes with it — open it, move it or cancel it from any device.",
  "flow.confirmed.promo.title": "Use Lura next time",
  "flow.confirmed.promo.body": "Create an account for easier booking and appointment management in the future.",
  "flow.confirmed.promo.create": "Create an account",
  "flow.confirmed.promo.get": "Get Lura",
  "flow.confirmed.promo.open": "Open Lura",
  "flow.confirmed.promo.dismiss": "Dismiss the Lura account suggestion",
  "flow.confirmed.closing": "No account needed — this booking is confirmed either way. Keep these booking details for your records.",
  "flow.confirmed.closing.bare": "Keep these booking details for your records.",
  "flow.outcome.payAtAppointment": "Pay at the appointment",
  "flow.outcome.email": "Email",
  "flow.outcome.nothingCharged": "",
  "flow.outcome.zoneNote": "Times are shown in {business}’s local time.",
  "flow.outcome.where": "Where",
  "flow.outcome.confirmation": "Confirmation",
  "flow.outcome.confirmationNumber": "Confirmation number",
  "flow.outcome.referenceNumber": "Reference number",
  "flow.outcome.unavailableValue": "Unavailable",
  // copy-1 (Founder-approved, 2026-10-06): the document title of every
  // booking outcome page, "Booking details · <business> · Lura". Stable and
  // non-committal: a title outlives the state in history and bookmarks, so it
  // never says booked, confirmed or requested.
  "flow.outcome.pageTitle": "Booking details",
  "flow.outcome.receiptUnavailable.title": "Some appointment details are unavailable",
  "flow.outcome.receiptUnavailable.body": "",
  "flow.outcome.receiptUnavailable.support": "Contact Support",
  "flow.outcome.unauthorized.title": "We can’t confirm what happened",
  "flow.outcome.unauthorized.body": "Your request reached {business} but we couldn’t read the result. Don’t book again — contact them to check before you do.",
  "flow.review.nohold.title": "Choose your time",
  "flow.review.nohold.body": "",
  "flow.review.nohold.action": "Pick a time",
  "flow.review.uncertain.title": "Check your booking",
  "flow.review.uncertain.body": "Check the result before booking again.",
  "flow.review.uncertain.action": "Check booking",
  "flow.review.uncertain.busy": "Checking…",
  "flow.review.uncertain.bodyAgain": "The result is still unavailable. Check before booking again.",
  "flow.review.settings.title": "The booking settings changed",
  "flow.review.settings.body": "Review the updated service and price.",
  "flow.review.settings.action": "Start again",
  "flow.review.accountRequired.title": "{business} only takes bookings from Lura accounts",
  "flow.review.accountRequired.body": "Nothing was booked. Sign in with your Lura account before trying again, or contact {business} for help.",
  "flow.review.alreadyBooked.title": "You already have this booking",
  "flow.review.alreadyBooked.body": "",
} as const;
